import React, {Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormControl, Row} from 'react-bootstrap';

import {BaseTableFilter} from "../../Common/Tables/BaseTableFilter";

export class PermitsTableFilter extends BaseTableFilter {
    constructor(props) {
        super(props);

        this.setInitialState({
            textFilter: ""
        });
    }

    @autobind
    generateFilters() {
        const { textFilter } = this.state || {};
        let filters = [];

        if(textFilter != "") {
            const uppercaseFilter = textFilter.toUpperCase();
            filters.push({
                code: 'textFilter',
                isSet: true,
                logic: x => (
                    x?.permitNumber?.toUpperCase().includes(uppercaseFilter) ||
                    x?.PermitType?.name?.toUpperCase().includes(uppercaseFilter) ||
                    x?.PermitType?.PermitOrganization?.name?.toUpperCase().includes(uppercaseFilter)
                )
            });
        }

        this.updateFilters(filters);
    }

    @autobind
    updateTextFilter(event) {
        this.setState({ textFilter: event.target.value }, _ => this.generateFilters());
    }

    @autobind
    _render() {
        const { textFilter } = this.state || {};

        return <Fragment>
            <Col lg={4} sm={4} xs={12} />
            <Col lg={8} sm={8} xs={12}>
                 <Row>
                     <Col xs={12} md={12} className="d-flex align-items-center">
                         <div className="float-right bottom10" style={{width: '215px'}}>
                             <FormControl
                                 style={{width: '100%'}}
                                 type="text"
                                 value={textFilter}
                                 placeholder="Search Permits"
                                 onChange={this.updateTextFilter}
                             />
                         </div>
                     </Col>
                 </Row>
                 <Row />
            </Col>
        </Fragment>;
    }
}
